module.exports = __webpack_public_path__ + "img/9.74796e29.svg";